// extracted by mini-css-extract-plugin
module.exports = {"item":"TestimonialRating_theme2_item__TPrXs","star":"TestimonialRating_theme2_star__yCvEL","star_wrapper":"TestimonialRating_theme2_star_wrapper__gqaT0"};